import React from "react";
import { Tree } from "primereact/tree";
import { Accordion, AccordionTab } from "primereact/accordion";
import "./category-left-view-new.css";

const CategoryLeftViewNew = ({
  categoriesDataLeft,
  selectedKeys,
  setSelectedKeys,
  searchQuery,
}: any) => {
  return (
    <>
      <Accordion>
        <AccordionTab header="Category">
          <Tree
            className="category-tree-filter"
            value={categoriesDataLeft}
            filter
            filterMode="strict"
            selectionMode="checkbox"
            selectionKeys={selectedKeys}
            onSelectionChange={(e) => setSelectedKeys(e.value)}
            // Enable propagation for parent-child relationship
            propagateSelectionUp={true}
            propagateSelectionDown={true}
          />
        </AccordionTab>
      </Accordion>
    </>
  );
};

export default CategoryLeftViewNew;
